var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{attrs:{"label":_vm.label,"class-name":_vm.className,"is-disabled":_vm.isDisabled},on:{"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }